<template>
  <span :class="['status-tag', statusClass]">
    {{ displayText }}
  </span>
</template>

<script>
export default {
  name: 'StatusTag',
  props: {
    status: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'default'
    },
    customMap: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    statusClass() {
      const classMap = {
        active: 'active',
        enabled: 'active',
        normal: 'active',
        inactive: 'inactive',
        disabled: 'inactive',
        pending: 'pending',
        waiting: 'pending',
        approved: 'approved',
        passed: 'approved',
        rejected: 'rejected',
        denied: 'rejected',
        processed: 'processed',
        completed: 'processed',
        replied: 'replied',
        ...this.customMap
      }
      return classMap[this.status] || this.status
    },
    displayText() {
      const textMap = {
        active: '正常',
        enabled: '正常',
        normal: '正常',
        inactive: '禁用',
        disabled: '禁用',
        pending: '待审核',
        waiting: '待处理',
        approved: '已通过',
        passed: '已通过',
        rejected: '已拒绝',
        denied: '已拒绝',
        processed: '已处理',
        completed: '已完成',
        replied: '已回复',
        ...this.customMap
      }
      return textMap[this.status] || this.status
    }
  }
}
</script>

<style scoped>
.status-tag {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 12px;
}

.status-tag.active {
  background: #27ae60;
  color: white;
}

.status-tag.inactive {
  background: #bdc3c7;
  color: white;
}

.status-tag.pending {
  background: #f39c12;
  color: white;
}

.status-tag.approved {
  background: #27ae60;
  color: white;
}

.status-tag.rejected {
  background: #e74c3c;
  color: white;
}

.status-tag.processed {
  background: #d4edda;
  color: #155724;
}

.status-tag.replied {
  background: #e8f5e9;
  color: #4caf50;
}
</style>
